
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Confirm from 'vux/src/components/confirm/index.vue'


export default {
directives: {TransferDom},
components:{Confirm},
props: ['acr001','PayShow','sum','acr002','zcuserid','zctoken','zcnickname','foundation','statuNum','ifDemandProject','user_type'],
data () {
return {
attention: this.concern, // 1为关注 0为未关注


showconfirm: false,
cont: '您还未登录，请登录后关注！',
beforeAlert: false,
cont1: '<p>尚未登录，可以点击“匿名支持”进行捐赠，也可以前往登录后再进行实名支持</p>',
ActChannel_strs:'',
DemandProject:1,
crowdId:''
}
},
watch:{
ifDemandProject(v,n){
this.DemandProject=v
},
acr001(v){
this.crowdId=v
}
},
methods: {
goDt() {
this.$emit("goEdit")
},
wxchat () {
var self = this;
this.$https.get(this.BASE_URL+'uts/invitationCode/wxAuthorization',{params:{
'code':this.code
}}).then( data => {

self.zcuserid = res.data.userId;
self.zctoken = res.data.logintoken;
self.zcnickname = res.data.nickname

localStorage.setItem('zcuserid',res.data.userId);
localStorage.setItem('zcopenid',res.data.openid);
localStorage.setItem('zcnickname',res.data.nickname);
localStorage.setItem('zctoken',self.zctoken);

})
},
helpLink(){
if(this.DemandProject==1){
console.log('有关联：ifDemandProject = ',this.DemandProject,'==',this.acr001)
this.$router.push('/dockingList/'+this.zcuserid+'/'+encodeURIComponent(this.zcnickname)+'/'+this.zctoken+'?acr001='+this.acr001)
return false
}
if(this.PayShow==''||this.PayShow==null){
this.$emit('Event_s',true);
return false;
}
if(this.isWeixinCient()){

if(localStorage.getItem('zcuserid') != undefined){
this.zcuserid = localStorage.getItem('zcuserid');
this.zcnickname = localStorage.getItem('zcnickname');
}
if(localStorage.getItem('zcopenid') =='undefined' || localStorage.getItem('zcopenid')  == undefined || localStorage.getItem('zcopenid') == '' ||localStorage.getItem('zcopenid') == null){

window.location.href="https://open.weixin.qq.com/connect/oauth2/authorize?appid="+this.wechatAppid+"&redirect_uri=" + encodeURIComponent( this.appjump_url+"/pages/index"+this.ActChannel_strs)+"&scope=snsapi_userinfo&response_type=code&state=wxh5267689457315#wechat_redirect"
}else{




window.location.href = this.appjump_url+'/pages/index/?#/zchelphe/'+this.acr001+'/'+this.sum+'/'+encodeURIComponent(this.acr002)+'/'+this.zcuserid+'/'+this.zctoken+'/'+encodeURIComponent(this.zcnickname)+'/null/null/null/'+encodeURIComponent(this.foundation)+this.ActChannel_strs
}
}else{


if(this.zctoken == '(null)' || this.zctoken == undefined || this.zctoken == 'undefined' || this.zctoken == '' || this.zctoken == null || this.zctoken == 'null'){
var ua = window.navigator.userAgent;
console.log(ua);

var isTxNews = ua.match(/qqnews\/([\.\d]+)/i);

var isYlxd = /ulxdapp/.test(navigator.userAgent.toLowerCase());

var isSunland = ua.match(/sunland/i);

var isLiePinAndroid = (ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1) && ua.indexOf('android-tongdao-app') > -1;
var isLiePinIos = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) && ua.indexOf('ios-tongdao-app') > -1;
var isLiePin = isLiePinAndroid || isLiePinIos;

if((isTxNews&&isTxNews[1]) || isYlxd || isSunland || isLiePinAndroid){

this.beforeAlert=false;
this.$router.push('/zchelphe/'+this.acr001+'/'+this.sum+'/'+encodeURIComponent(this.acr002)+'/'+this.zcuserid+'/'+this.zctoken+'/'+encodeURIComponent(this.zcnickname)+'/null/null/null/'+encodeURIComponent(this.foundation)+this.ActChannel_strs)
}else if(isLiePinIos){
console.log('这是猎聘IOS')
}else if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {


this.beforeAlert=true;
}else{
this.beforeAlert=true;
}

}else{

var ua = window.navigator.userAgent;
console.log(ua);

var isTxNews = ua.match(/qqnews\/([\.\d]+)/i);

var isYlxd = /ulxdapp/.test(navigator.userAgent.toLowerCase());

var isSunland = ua.match(/sunland/i);

var isLiePinAndroid = (ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1) && ua.indexOf('android-tongdao-app') > -1;
var isLiePinIos = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) && ua.indexOf('ios-tongdao-app') > -1;
var isLiePin = isLiePinAndroid || isLiePinIos;

if((isTxNews&&isTxNews[1]) || isYlxd || isSunland || isLiePinAndroid){

this.beforeAlert=false;
this.$router.push('/zchelphe/'+this.acr001+'/'+this.sum+'/'+encodeURIComponent(this.acr002)+'/'+this.zcuserid+'/'+this.zctoken+'/'+encodeURIComponent(this.zcnickname)+'/null/null/null/'+encodeURIComponent(this.foundation)+this.ActChannel_strs)
}else if(isLiePinIos){
console.log('这是猎聘IOS')
}else if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) { //判断iPhone|iPad|iPod|iOS
var jsonstr = ''+this.appjump_url+'/pages/index/#/zchelphe/'+this.acr001+'/'+this.sum+'/'+encodeURIComponent(this.acr002)+'/'+this.zcuserid+'/'+this.zctoken+'/'+encodeURIComponent(this.zcnickname)+'/null/null/null/'+encodeURIComponent(this.foundation)+this.ActChannel_strs;

this.beforeAlert=false;
window.native.appLoadUrl(jsonstr)



















} else if (/(Android)/i.test(navigator.userAgent)) {  //判断Android
this.beforeAlert=false;
this.$router.push('/zchelphe/'+this.acr001+'/'+this.sum+'/'+encodeURIComponent(this.acr002)+'/'+this.zcuserid+'/'+this.zctoken+'/'+encodeURIComponent(this.zcnickname)+'/null/null/null/'+encodeURIComponent(this.foundation)+this.ActChannel_strs)
}else{
this.showToast('','text','请在app或微信内打开！','20em','','')
}
}
}
},
beforeConfirm(){
this.beforeAlert=false;

var u = navigator.userAgent
let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); 
if(isiOS){
window.webkit.messageHandlers.AppReturnToLoginPage.postMessage('callNative')
}else{
javascript: android.AppReturnToLoginPage('callNative')
}

},
beforeCancel(){


this.beforeAlert=false;
if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) { //判断iPhone|iPad|iPod|iOS
var jsonstr = ''+this.appjump_url+'/pages/index/#/zchelphe/'+this.acr001+'/'+this.sum+'/'+encodeURIComponent(this.acr002)+'/'+'null'+'/'+'null'+'/'+encodeURIComponent('社会帮扶网-匿名')+'/null/null/null/'+encodeURIComponent(this.foundation)+this.ActChannel_strs;

window.native.appLoadUrl(jsonstr)
} else if (/(Android)/i.test(navigator.userAgent)) {  //判断Android
this.$router.push('/zchelphe/'+this.acr001+'/'+this.sum+'/'+encodeURIComponent(this.acr002)+'/'+'null'+'/'+'null'+'/'+encodeURIComponent('社会帮扶网-匿名')+'/null/null/null/'+encodeURIComponent(this.foundation)+this.ActChannel_strs)
}else{
this.showToast('','text','请在app或微信内打开！','20em','','')
}
}
},
mounted () {

console.log(this.user_type+'user_typeuser_typeuser_typeuser_typeuser_typeuser_type')
console.log('zcfooter-mounted:::::'+this.zctoken)

this.ActChannel_strs = (this.$route.query.channelCode?('?channelCode='+this.$route.query.channelCode):'')+(this.$route.query.ActCode?('&ActCode='+this.$route.query.ActCode):'');
}
}



// WEBPACK FOOTER //
// ./src/crowd_fund/zcfooter.vue